export const COUNTRIES = [
    {
        "name": "UNITED ARAB EMIRATES",
        "code": "AE",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/united-arab-emirates-circular.png" />
    },
    {
        "name": "ANGUILLA",
        "code": "AI",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/anguilla-circular.png" />,
    },
    {
        "name": "ANTARCTICA",
        "code": "AQ",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/antarctica-circular.png" />,
    },
    {
        "name": "ARGENTINA",
        "code": "AR",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/argentina-circular.png" />,
    },
    {
        "name": "AUSTRIA",
        "code": "AT",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/austria-circular.png" />,
    },
    {
        "name": "AUSTRALIA",
        "code": "AU",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/australia-circular.png" />,
    },
    {
        "name": "ARUBA",
        "code": "AW",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/aruba-circular.png" />,
    },
    {
        "name": "BARBADOS",
        "code": "BB",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/barbados-circular.png" />,
    },
    {
        "name": "BANGLADESH",
        "code": "BD",
        "count": "10",
        "flag": <img src="https://img.icons8.com/color/48/000000/bangladesh-circular.png" />,
    },
    {
        "name": "BELGIUM",
        "code": "BE",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/belgium-circular.png" />,
    },
    {
        "name": "BULGARIA",
        "code": "BG",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/bulgaria-circular.png" />,
    },
    {
        "name": "BAHRAIN",
        "code": "BH",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/bahrain-circular.png" />,
    },
    {
        "name": "BERMUDA",
        "code": "BM",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/bermuda-circular.png" />,
    },
    {
        "name": "BRUNEI",
        "code": "BN",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/brunei-darussalam-circular.png" />,
    },
    {
        "name": "BRAZIL",
        "code": "BR",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/brazil-circular.png" />,
    },
    {
        "name": "BAHAMAS",
        "code": "BS",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/bahamas-circular.png" />,
    },
    {
        "name": "BOTSWANA",
        "code": "BW",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/botswana-circular.png" />,
    },
    {
        "name": "CANADA",
        "code": "CA",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/canada-circular.png" />,
    },
    {
        "name": "DEMOCRATIC REPUBLIC OF CONGO ",
        "code": "CD",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/congo-circular.png" />,
    },
    {
        "name": "SWITZERLAND",
        "code": "CH",
        "count": "20",
        "flag": <img src="https://img.icons8.com/color/48/000000/switzerland-circular.png" />,
    },
    {
        "name": "CHILE",
        "code": "CL",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/chile-circular.png" />,
    },
    {
        "name": "CHINA",
        "code": "CN",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/china-circular.png" />,
    },
    {
        "name": "COLOMBIA",
        "code": "CO",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/colombia-circular.png" />,
    },
    {
        "name": "COSTA RICA",
        "code": "CR",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/casta-rica-circular.png" />,
    },
    {
        "name": "CHRISTMAS ISLANDS",
        "code": "CX",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/christmas-island-circular.png" />,
    },
    {
        "name": "CYPRUS",
        "code": "CY",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/cyprus-circular.png" />,
    },
    {
        "name": "CZECH REPUBLIC",
        "code": "CZ",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/czech-republic-circular.png" />,
    },
    {
        "name": "GERMANY",
        "code": "DE",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/germany-circular.png" />,
    },
    {
        "name": "DENMARK",
        "code": "DK",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/denmark-circular.png" />,
    },
    {
        "name": "ECUADOR",
        "code": "EC",
        "count": "30",
        "flag": <img src="https://img.icons8.com/color/48/000000/ecuador-circular.png" />,
    },
    {
        "name": "ESTONIA",
        "code": "EE",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/estonia-circular.png" />,
    },
    {
        "name": "EGYPT",
        "code": "EG",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/egypt-circular.png" />,
    },
    {
        "name": "SPAIN",
        "code": "ES",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/spain2-circular.png" />,
    },
    {
        "name": "ETHIOPIA",
        "code": "ET",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/ethiopia-circular.png" />,
    },
    {
        "name": "FINLAND",
        "code": "FI",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/finland-circular.png" />,
    },
    {
        "name": "FIJI",
        "code": "FJ",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/fiji-circular.png" />,
    },
    {
        "name": "FRANCE",
        "code": "FR",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/france-circular.png" />,
    },
    {
        "name": "GABON",
        "code": "GA",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/gabon-circular.png" />,
    },
    {
        "name": "GREAT BRITAIN",
        "code": "GB",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/great-britain-circular.png" />,
    },
    {
        "name": "GHANA",
        "code": "GH",
        "count": "40",
        "flag": <img src="https://img.icons8.com/color/48/000000/ghana-circular.png" />,
    },
    {
        "name": "GREENLAND",
        "code": "GL",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/greenland-circular.png" />,
    },
    {
        "name": "GREECE",
        "code": "GR",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/greece-circular.png" />,
    },
    {
        "name": "HONG KONG",
        "code": "HK",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/hongkong-circular.png" />,
    },
    {
        "name": "CROATIA",
        "code": "HR",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/croatia-circular.png" />,
    },
    {
        "name": "HUNGARY",
        "code": "HU",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/hungary-circular.png" />,
    },
    {
        "name": "INDONESIA",
        "code": "ID",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/indonesia-circular.png" />,
    },
    {
        "name": "IRELAND",
        "code": "IE",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/ireland-circular.png" />,
    },
    {
        "name": "ISRAEL",
        "code": "IL",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/israel-circular.png" />,
    },
    {
        "name": "INDIA",
        "code": "IN",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/india-circular.png" />,
    },
    {
        "name": "ITALY",
        "code": "IT",
        "count": "50",
        "flag": <img src="https://img.icons8.com/color/48/000000/italy-circular.png" />,
    },
    {
        "name": "JAMAICA",
        "code": "JM",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/jamaica-circular.png" />,
    },
    {
        "name": "JORDAN",
        "code": "JO",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/jordan-circular.png" />,
    },
    {
        "name": "JAPAN",
        "code": "JP",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/japan-circular.png" />,
    },
    {
        "name": "KENYA",
        "code": "KE",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/kenya-circular.png" />,
    },
    {
        "name": "REPUBLIC OF KOREA",
        "code": "KR",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/south-korea-circular.png" />,
    },
    {
        "name": "KUWAIT",
        "code": "KW",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/kuwait-circular.png" />,
    },
    {
        "name": "LIECHTENSTEIN",
        "code": "LI",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/liechtenstein-circular.png" />,
    },
    {
        "name": "LITHUANIA",
        "code": "LT",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/lithuania-circular.png" />,
    },
    {
        "name": "LUXEMBOURG",
        "code": "LU",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/luxembourg-circular.png" />,
    },
    {
        "name": "LATVIA",
        "code": "LV",
        "count": "60",
        "flag": <img src="https://img.icons8.com/color/48/000000/latvia-circular.png" />,
    },
    {
        "name": "MONACO",
        "code": "MC",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/monaco-circular.png" />,
    },
    {
        "name": "MONTENEGRO",
        "code": "ME",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/montenegro-circular.png" />,
    },
    {
        "name": "MACAO",
        "code": "MO",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/macao-circular.png" />,
    },
    {
        "name": "MALTA",
        "code": "MT",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/malta-circular.png" />,
    },
    {
        "name": "MAURITIUS",
        "code": "MU",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/mauritius-circular.png" />,
    },
    {
        "name": "MALDIVES",
        "code": "MV",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/maldives-circular.png" />,
    },
    {
        "name": "MEXICO",
        "code": "MX",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/mexico-circular.png" />,
    },
    {
        "name": "MALAYSIA",
        "code": "MY",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/malaysia-circular.png" />,
    },
    {
        "name": "NIGERIA",
        "code": "NG",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/nigeria-circular.png" />,
    },
    {
        "name": "NETHERLANDS",
        "code": "NL",
        "count": "70",
        "flag": <img src="https://img.icons8.com/color/48/000000/netherlands-circular.png" />,
    },
    {
        "name": "NORWAY",
        "code": "NO",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/norway-circular.png" />,
    },
    {
        "name": "NEW ZEALAND",
        "code": "NZ",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/new-zealand-circular.png" />,
    },
    {
        "name": "PANAMA",
        "code": "PA",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/panama-circular.png" />,
    },
    {
        "name": "PERU",
        "code": "PE",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/peru-circular.png" />,
    },
    {
        "name": "PHILIPPINES",
        "code": "PH",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/philippines-circular.png" />,
    },
    {
        "name": "PAKISTAN",
        "code": "PK",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/pakistan-circular.png" />,
    },
    {
        "name": "POLAND",
        "code": "PL",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/poland-circular.png" />,
    },
    {
        "name": "PUERTO RICO",
        "code": "PR",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/puerto-rico-circular.png" />,
    },
    {
        "name": "ROMANIA",
        "code": "RO",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/romania-circular.png" />,
    },
    {
        "name": "SERBIA",
        "code": "RS",
        "count": "80",
        "flag": <img src="https://img.icons8.com/color/48/000000/sernia-circular.png" />,
    },
    {
        "name": "RUSSIAN FEDERATION",
        "code": "RU",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/russian-federation-circular.png" />,
    },
    {
        "name": "SAUDI ARABIA",
        "code": "SA",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/saudi-arabia-circular.png" />,
    },
    {
        "name": "SEYCHELLES",
        "code": "SC",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/seychelles-circular.png" />,
    },
    {
        "name": "SWEDEN",
        "code": "SE",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/sweden-circular.png" />,
    },
    {
        "name": "SINGAPORE",
        "code": "SG",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/singapore-circular.png" />,
    },
    {
        "name": "SLOVAKIA",
        "code": "SK",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/slovakia-circular.png" />,
    },
    {
        "name": "SAN MARINO",
        "code": "SM",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/san-marino-circular.png" />,
    },
    {
        "name": "TURKS AND CAICOS",
        "code": "TC",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/turks-and-caicos-islands-circular.png" />,
    },
    {
        "name": "THAILAND",
        "code": "TH",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/thailand-circular.png" />,
    },
    {
        "name": "TURKEY",
        "code": "TR",
        "count": "90",
        "flag": <img src="https://img.icons8.com/color/48/000000/turkey-circular.png" />,
    },
    {
        "name": "TRINIDAD TOBAGO",
        "code": "TT",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/trinidad-and-tobago-circular.png" />,
    },
    {
        "name": "TAIWAN",
        "code": "TW",
        "count": "",
        "flag": <img src="https://i.ibb.co/bbW3rPT/taiwan-1.png" width={42} alt="taiwan-1" border="0" />,
    },
    {
        "name": "UKRAINE",
        "code": "UA",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/ukraine-circular.png" />,
    },
    {
        "name": "UNITED STATES OF AMERICA",
        "code": "US",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/usa-circular.png" />,
    },
    {
        "name": "URUGUAY",
        "code": "UY",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/uruguay-circular.png" />,
    },
    {
        "name": "VENEZUELA",
        "code": "VE",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/venezuela-circular.png" />,
    },
    {
        "name": "BRITISH VIRGIN ISLANDS",
        "code": "VG",
        "count": "",
        "flag": <img src="https://i.ibb.co/hf4Bk1G/British-Virgin-Islands-1.png" width={42} alt="British-Virgin-Islands-1" border="0" />
    },
    {
        "name": "US VIRGIN ISLANDS",
        "code": "VI",
        "count": "",
        "flag": <img src="https://i.ibb.co/qkfmXjZ/Virgin-Islands-1.png" width={42} alt="Virgin-Islands-1" border="0" />
    },
    {
        "name": "VIETNAM",
        "code": "VN",
        "count": "",
        "flag": <img src="https://img.icons8.com/color/48/000000/vietnam-circular.png" />,
    },
    {
        "name": "SOUTH AFRICA",
        "code": "ZA",
        "count": "100",
        "flag": <img src="https://img.icons8.com/color/48/000000/south-africa-circular.png" />,
    }
]